import * as Sentry from "@sentry/react";
import { actions, partnerSelector } from "@dashboard/config/redux";
import { StorageItem } from "@dashboard/constants/storage-items";
import { UserAddon } from "@dashboard/entities/user-addon";
import { fetchUserAddons } from "@dashboard/services/get-user-addons.services";
import { useDispatch, useSelector } from "react-redux";

export const useUserAddons = () => {
  const dispatch = useDispatch();
  const user = useSelector(partnerSelector);

  const getUserAddons = async (): Promise<UserAddon[] | null> => {
    if (!user) return null;

    const token =
      localStorage.getItem(StorageItem.Token)?.replaceAll('"', "") || "";

    try {
      const addons = await fetchUserAddons({ token });
      if (addons) {
        dispatch(actions.setAvailableAddons(addons));
      }
      return addons;
    } catch (error) {
      const reason =
        error instanceof Error ? error.message : String(error);
      console.error(
        "[useUserAddons] Failed to fetch user addons:",
        reason,
        error
      );
      Sentry.captureException(error, {
        tags: { hook: "useUserAddons" },
        extra: { userId: user.userId, endpoint: "/api/ms/addon/addon-user" },
      });
      return null;
    }
  };

  return {
    getUserAddons,
  };
};
